import React from 'react';

import LinkWithParams from '../../elements/LinkWithParams';
import { PERMISSION } from '../../helpers/Permissions';

import AdminsList from './AdminsList';

function AdminPage({ onlySuperadmins = false }: { onlySuperadmins?: boolean }) {
    const title = onlySuperadmins ? 'All Super Admins' : 'All Admins';

    return (
        <>
            <LinkWithParams
                title="Create new Admin"
                params={[{ key: 'admin_create', value: 'true' }]}
                permissions={[PERMISSION.CREATE_ADMIN]}
                className="mb-3"
            />
            <AdminsList
                source={onlySuperadmins ? 'super-admins' : undefined}
                cardTitle={title}
                onlySuperadmins={onlySuperadmins}
            />
        </>
    );
}

export default AdminPage;
